<template>
  <div class="bg-nav">
    <!-- NAVBAR -->
    <div>
      <Navbar />
    </div>
    <div class="bg-products-cot h-auto mb-12" style="height: auto !important">
      <div class="container">
        <!-- CATALOGUE -->
        <div class="container mx-auto my-12 bg-white/40">
          <div
            class="flex mb-8 text-base font-normal text-theme-9 cursor-pointer"
            @click="$router.back()"
          >
            <ArrowLeftIcon />Regresar
          </div>
          <div class="mb-12">
            <h1 class="font-crimson_pro text-3xl font-bold text-center text-theme-9">
              TÉRMINOS Y CONDICIONES DE USO
            </h1>
          </div>
          <div class="col-span-4 text-justify space-y-2">
            <p>
              Artículos Promocionales Brand In, S.A. DE C.V., con domicilio en
              <b
                >AVENIDA VASCO DE QUIROGA, NÚMERO 3900, A-401, SANTA FE
                CUAJIMALPA, ALCALDÍA CUAJIMALPA DE MORELOS, EN LA CIUDAD DE
                MÉXICO, CÓDIGO POSTAL 05348</b
              >, con Registro Federal de Contribuyentes (RFC)
              <b>APB131203PU9</b>, en adelante BRANDIN.
            </p>
            <p>
              Bienvenido a nuestro catálogo digital. Le solicitamos leer
              cuidadosamente los presentes Términos y Condiciones de Uso, así
              como nuestro Aviso de Privacidad, antes de utilizar nuestro sitio
              web o consultar el contenido del catálogo.
            </p>
            <p>
              El acceso, navegación y uso del catálogo digital implica que usted
              ha leído, entendido y aceptado expresamente todas las condiciones
              aquí establecidas, incluyendo aquellas incorporadas por
              referencia.
            </p>
            <p>
              Al acceder y utilizar el catálogo digital proporcionado por
              ARTICULOS PROMOCIONALES BRAND IN, S.A. DE C.V. (en adelante,
              “BRANDIN”) por cualquier otro medio electrónico, el Usuario
              (incluyendo distribuidores, clientes, terceros o público en
              general) acepta expresamente los presentes Términos y Condiciones
              de Uso, y manifiesta su consentimiento mediante medios
              electrónicos conforme a la legislación aplicable.
            </p>
            <p>
              En caso de no aceptar en alguna forma total o parcialmente estos
              Términos y Condiciones de Uso, el usuario, Distribuidor, público
              en general o tercero deberá abstenerse de acceder o utilizar el
              catálogo digital.
            </p>
            <p>
              BRANDIN podrá en cualquier momento y bajo las circunstancias que
              más le convengan, modificar, enmendar o cambiar los Términos y
              Condiciones de Uso del presente sitio web sin responsabilidad
              alguna, y los cuales entrarán en vigor en el momento mismo de su
              publicación, por lo que será exclusiva responsabilidad del
              Distribuidor asegurarse de tomar conocimiento de las condiciones
              aplicables.
            </p>
            <b>I. Reglas para el uso del catálogo:</b>
            <p>
              Todos los elementos contenidos en el catálogo digital de BRANDIN,
              incluyendo de forma enunciativa mas no limitativa: marcas, nombres
              comerciales, logotipos, diseños, contenidos visuales, textos,
              imágenes, material multimedia, nombres de dominio, elementos
              gráficos y programas de cómputo, se encuentran protegidos por la
              legislación nacional e internacional en materia de propiedad
              industrial e intelectual.
            </p>
            <p>
              Dichos elementos son propiedad de la Empresa o de terceros que han
              otorgado autorización o licencia para su uso, por lo que su
              reproducción, distribución, modificación o utilización no
              autorizada queda estrictamente prohibida, salvo que exista
              consentimiento expreso y por escrito del titular de los derechos.
            </p>
            <p>
              Los usuarios, distribuidores, clientes, terceros o cualquier
              persona que acceda o reciba el catálogo digital, reconocen y
              aceptan lo siguiente:
            </p>
            <ul class="list-disc pl-6">
              <li>
                El uso del catálogo se limita exclusivamente a fines
                informativos y personales, sin fines de lucro directo o
                indirecto.
              </li>
              <li>
                Queda prohibida la reproducción total o parcial del contenido
                por cualquier medio, salvo autorización expresa.
              </li>
              <li>
                No se permite modificar, alterar, suprimir ni utilizar de manera
                indebida avisos, marcas, logotipos, diseños o cualquier elemento
                que haga referencia a la propiedad del contenido.
              </li>
              <li>
                El acceso o consulta del catálogo no otorga en ningún caso
                licencia ni derecho alguno sobre los elementos protegidos por
                derechos de autor o propiedad industrial.
              </li>
            </ul>
            <p>
              Todos los derechos que no hayan sido expresamente concedidos en
              estos Términos y Condiciones están reservados a favor de ARTÍCULOS
              PROMOCIONALES BRAND IN, S.A. DE C.V., sus titulares legítimos o
              causahabientes.
            </p>
            <b>III. Modificaciones al catálogo digital </b>
            <p>
              BRANDIN se reserva el derecho de realizar, en cualquier momento y
              sin previo aviso, cambios, adiciones, correcciones o
              actualizaciones al contenido del catálogo digital, incluyendo
              productos, descripciones, precios, imágenes, condiciones
              comerciales o cualquier otra información incluida en el mismo.
            </p>
            <p>
              Dichas modificaciones podrán realizarse por razones comerciales,
              operativas, técnicas o de disponibilidad, sin que ello implique
              responsabilidad alguna por parte de la Empresa, ni genere derecho
              a reclamación o indemnización alguna a favor de los usuarios,
              distribuidores, clientes o terceros que hayan recibido versiones
              anteriores del catálogo.
            </p>
            <p>
              Las modificaciones entrarán en vigor al momento de su publicación,
              salvo que impliquen cambios sustanciales en las condiciones de
              transacción con consumidores finales, en cuyo caso se notificará
              previamente mediante los canales oficiales de la Empresa.
            </p>
            <b>IV. Fallas en el sistema y liberación de responsabilidad: </b>
            <p>
              BRANDIN, sus filiales y subsidiarias, no se hacen responsables por
              cualquier daño, pérdida o perjuicio que pudieran derivarse del
              uso, consulta o descarga del catálogo digital, incluyendo sin
              limitarse a errores en la información, diferencias visuales en los
              productos, o problemas técnicos derivados del medio electrónico
              por el cual se haya enviado dicho catálogo.
            </p>
            <p>El Usuario acepta que:</p>
            <ul class="list-disc pl-6">
              <li>
                La información contenida en el catálogo digital es de carácter
                informativo y referencial, por lo que no constituye una oferta
                vinculante de compra-venta ni garantiza disponibilidad inmediata
                de los productos.
              </li>
              <li>
                El envío del catálogo o de una cotización no implica la reserva
                ni confirmación de existencias, ya que los productos están
                sujetos a disponibilidad en inventario. Sin embargo, en caso de
                que el Usuario haya realizado un pago y el producto no se
                encuentre disponible, BRANDIN se obliga a reembolsar el monto
                correspondiente en un plazo máximo de 15 días hábiles.
              </li>
              <li>
                Las imágenes, colores, tonalidades y texturas pueden variar
                respecto al producto físico, debido a diferencias en la
                iluminación, resolución de pantalla o medios de reproducción
                utilizados.
              </li>
              <li>
                La Empresa no se responsabiliza por fallas técnicas, virus,
                interrupciones o errores que puedan presentarse durante el envío
                o recepción del catálogo digital por medios electrónicos.
              </li>
              <li>
                El contenido, productos o servicios ofrecidos por terceros que
                puedan ser mencionados, referenciados o vinculados en el
                catálogo o en comunicaciones derivadas de este. Dichos terceros
                son responsables de sus propios servicios y se encuentran
                sujetos a las disposiciones legales aplicables, incluyendo lo
                establecido en el Artículo 32 de la Ley Federal de Protección al
                Consumidor.
              </li>
            </ul>
            <p>
              El Usuario libera expresamente de toda responsabilidad a ARTICULOS
              PROMOCIONALES BRAND IN, S.A. DE C.V., por cualquier daño o
              afectación que pudiera sufrir su equipo o dispositivo al recibir,
              visualizar o descargar el catálogo digital.
            </p>
            <p>
              Lo anterior no limita los derechos irrenunciables de los
              consumidores previstos en la Ley Federal de Protección al
              Consumidor.
            </p>
            <b>V. Jurisdicción. </b>
            <p>
              Para la interpretación, cumplimiento y ejecución de los presentes
              Términos y Condiciones de Uso del catálogo digital, los usuarios,
              distribuidores, clientes, público en general o cualquier tercero
              que acceda o haga uso del mismo, se someten a las leyes aplicables
              de los Estados Unidos Mexicanos y, de manera expresa, a la
              jurisdicción de los tribunales competentes de la Ciudad de México,
              renunciando a cualquier otro fuero que por razón de domicilio
              presente o futuro, o por cualquier otra causa, pudiera
              corresponderles.
            </p>
            <p>
              Sin perjuicio de lo anterior, las partes procurarán resolver
              cualquier diferencia mediante negociación directa y, en su
              defecto, podrán someterse a mecanismos alternativos de solución de
              controversias antes de acudir a tribunales.
            </p>
            <b>VI. Aceptación. </b>
            <p>
              El acceso, recepción, consulta o uso del catálogo digital
              proporcionado por ARTICULOS PROMOCIONALES BRAND IN, S.A. DE C.V.
              implica la plena aceptación de los presentes Términos y
              Condiciones de Uso por parte del Usuario, ya sea distribuidor,
              cliente o tercero.
            </p>
            <p>
              El Usuario reconoce que ha leído, entendido y aceptado las
              disposiciones aquí contenidas, y se obliga a cumplirlas en todo
              momento. En caso de no estar de acuerdo con los presentes
              términos, deberá abstenerse de utilizar, compartir o consultar el
              catálogo digital bajo cualquier modalidad.
            </p>
          </div>
          <div class="flex flex-col w-full justify-end text-right">
            <b>Última versión de septiembre de 2025. </b>
            <p>
              Las versiones anteriores de los presentes Términos y Condiciones
            </p>
            <p>
              quedan sin efecto a partir de la entrada en vigor de esta versión.
            </p>
          </div>
        </div>
      </div>
    </div>
    <div>
      <Footer />
    </div>
  </div>
</template>

<script>
import Navbar from '@/components/navbar/Main.vue'
import Footer from '@/components/footer/Main.vue'

export default {
  components: {
    Navbar,
    Footer
  }
}
</script>

<style scoped>
.bg-nav {
  background: url('@/assets/images/COT-bg/img-slider-nav.svg');
  background-repeat: no-repeat;
  background-position: initial;
  backface-visibility: hidden;
  height: 480px;
  width: auto;
}

.bg-banner-2 {
  background: url('@/assets/images/COT-bg/img-banner2.svg');
  background-repeat: no-repeat;
  background-position: initial;
  backface-visibility: hidden;
  height: 600px;
  width: auto;
}

.bg-geometria {
  background: url('@/assets/images/COT-bg/img-geometria.svg');
  background-repeat: no-repeat;
  background-position: center;
  backface-visibility: hidden;
  height: 600px;
  width: auto;
}

.bg-cat-bg {
  background: url('@/assets/images/COT-bg/img-categorias.svg');
  background-repeat: no-repeat;
  background-position: center;
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
  height: 60px;
  width: auto;
  padding-top: 2px;
}

.bg-banner {
  background: linear-gradient(
    111.68deg,
    rgba(255, 255, 255, 0.29) 7.59%,
    rgba(255, 255, 255, 0.39) 102.04%
  );
  backdrop-filter: blur(8px) brightness(100%);
  border: 3px solid rgba(255, 255, 255, 0.28);
}

.backtest {
  background: url('@/assets/images/COT-bg/img-banner2.svg');
  background-position: bottom;
  background-repeat: no-repeat;
  background-size: cover;
}

.bg-banner-cot {
  background: url('@/assets/images/COT-bg/img-banner2.svg');
  background-repeat: no-repeat;
  background-position: center;
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
  height: 198px;
  width: auto;
  padding-top: 0px;
  margin-bottom: 18rem;
}

.bg-banner-cot-res {
  background: url('@/assets/images/COT-bg/img-banner2.svg');
  background-repeat: no-repeat;
  background-position: center;
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
  height: 445px;
  width: auto;
  padding-top: 0px;
}

.bg-products-cot {
  background: url('@/assets/images/COT-bg/img-products.svg');
  background-repeat: no-repeat;
  background-position: inherit;
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
  height: 230px;
  width: auto;
  padding-top: 2px;
}

.bg-help {
  background: url('@/assets/images/COT-bg/img-help.svg');
  background-repeat: no-repeat;
  background-position: right;
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
  height: 350px;
  width: auto;
  padding-top: 2px;
}

.btn-deg {
  background: linear-gradient(89.75deg, #e85c04 0.17%, #faa306 99.78%);
  transition: 0.3s;
  outline: 1px solid transparent;
  width: 200px;
  font-weight: 600;
}

.b-cot-card {
  background-image: radial-gradient(
      circle at 100% 100%,
      transparent 18px,
      #ffffff 18px,
      #ffffff 21px,
      transparent 21px
    ),
    linear-gradient(to right, #ffffff, #ffffff),
    radial-gradient(
      circle at 0% 100%,
      transparent 18px,
      #ffffff 18px,
      #ffffff 21px,
      transparent 21px
    ),
    linear-gradient(to bottom, #ffffff, #f6f6e0),
    radial-gradient(
      circle at 0% 0%,
      transparent 18px,
      #ffffff21 18px,
      #ffffff21 21px,
      transparent 21px
    ),
    linear-gradient(to left, #ffffff21, #ffffff21),
    radial-gradient(
      circle at 100% 0%,
      transparent 18px,
      #ffffff21 18px,
      #ffffff21 21px,
      transparent 17px
    ),
    linear-gradient(to top, #ffffff21, #ffffff);
  background-size: 21px 21px, calc(100% - 42px) 3px, 21px 21px,
    3px calc(100% - 42px);
  background-position: top left, top center, top right, center right,
    bottom right, bottom center, bottom left, center left;
  background-repeat: no-repeat;
  border-radius: 24px;
}

.bg-card {
  background: #ffffff21;
  border-radius: 24px;
}

.eventos {
  background-image: url('@/assets/images/COT-img/eventos/fiestas-1.svg');
}

.flip-card {
  background-color: transparent;
  perspective: 1000px;
}

.flip-card-inner {
  position: relative;
  width: 100%;
  height: 100%;
  text-align: center;
  transition: transform 0.6s;
  transform-style: preserve-3d;
}

.flip-card:hover .flip-card-inner {
  transform: rotateY(180deg);
}

.flip-card-front,
.flip-card-back {
  position: absolute;
  width: 100%;
  height: 100%;
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
}

.flip-card-front {
  background: linear-gradient(
    111.68deg,
    rgba(255, 255, 255, 0.29) 7.59%,
    rgba(255, 255, 255, 0.39) 102.04%
  );
  border: 3px solid rgba(255, 255, 255, 0.28);
  backdrop-filter: blur(22px);
  /* Note: backdrop-filter has minimal browser support */
  border-radius: 20px;
}

.flip-card-back {
  background: linear-gradient(
    111.68deg,
    rgba(255, 255, 255, 0.29) 7.59%,
    rgba(255, 255, 255, 0.39) 102.04%
  );
  border: 3px solid rgba(255, 255, 255, 0.28);
  backdrop-filter: blur(22px);
  border-radius: 20px;
  transform: rotateY(180deg);
}

.brandin-card {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  font-size: 16px;
}

/* SEARCH CONTROL CSS */
.form-control {
  border-color: transparent;
}

.input-group > .form-control:focus {
  border-color: transparent;
  box-shadow: inset 0 0 0 1px transparent;
}
.btn-link:hover {
  background-color: rgba(0, 0, 0, 0.05);
}
.btn-link:active,
.btn-link.active {
  background-color: rgba(0, 0, 0, 0.05);
}
.btn-link:focus,
.btn-link.focus {
  background-color: rgba(0, 0, 0, 0.05);
}
.btn-link:active:focus,
.btn-link.active:focus {
  background-color: rgba(0, 0, 0, 0.05);
}

.i-search {
  border-radius: 6px 0px 0px 6px !important;
  background: rgb(241, 241, 241) !important;
  border-color: #cacaca !important;
  border-bottom-width: 1px !important;
  border-style: solid none solid solid !important;
  border-top-width: 1px !important;
  border-left-width: 1px !important;
  border-right-width: initial !important;
}
.i-search-form {
  background: rgb(241, 241, 241);
  border-color: #cacaca;
  border-bottom-width: 1px;
  border-style: solid solid solid none;
  border-top-width: 1px;
  border-right-width: 1px;
  border-left-width: initial;
  border-radius: 0px 6px 6px 0px;
  box-shadow: 0 0 0;
}
div > b {
  margin-top: 8px;
}
</style>
